import React from 'react';
import { TrendingUp, PiggyBank, ArrowUpRight } from 'lucide-react';

const GrowthSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <TrendingUp className="w-5 h-5 mr-2 text-green-500" />
        Параметры роста и реинвестирования
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Включение роста дивидендов */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeDividendGrowth"
              checked={formData.includeDividendGrowth}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать рост дивидендов со временем
            </span>
          </label>
        </div>

        {/* Темп роста дивидендов (отображается только если включен рост) */}
        {formData.includeDividendGrowth && (
          <div>
            <label htmlFor="dividendGrowthRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <ArrowUpRight className="w-4 h-4 mr-2 text-green-500" />
              Годовой рост дивидендов (%)
            </label>
            <input
              type="text"
              id="dividendGrowthRate"
              name="dividendGrowthRate"
              value={formData.dividendGrowthRate}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.dividendGrowthRate ? 'input-error' : ''}`}
              placeholder="Введите процент роста"
            />
            {errors.dividendGrowthRate && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.dividendGrowthRate}
              </p>
            )}
          </div>
        )}

        {/* Включение реинвестирования дивидендов */}
        <div className="col-span-full mt-2">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeReinvestment"
              checked={formData.includeReinvestment}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Реинвестировать полученные дивиденды
            </span>
          </label>
        </div>

        {/* Процент реинвестирования (отображается только если включено реинвестирование) */}
        {formData.includeReinvestment && (
          <div>
            <label htmlFor="reinvestmentRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <PiggyBank className="w-4 h-4 mr-2 text-green-500" />
              Процент реинвестирования (%)
            </label>
            <input
              type="text"
              id="reinvestmentRate"
              name="reinvestmentRate"
              value={formData.reinvestmentRate}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.reinvestmentRate ? 'input-error' : ''}`}
              placeholder="Введите процент реинвестирования"
            />
            {errors.reinvestmentRate && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.reinvestmentRate}
              </p>
            )}
          </div>
        )}
      </div>

      <div className="mt-4 bg-green-100 dark:bg-green-900/30 p-3 rounded-lg">
        <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">Рост и реинвестирование</h4>
        <p className="text-xs text-green-600 dark:text-green-400">
          Многие успешные компании ежегодно увеличивают размер дивидендов. Реинвестирование позволяет 
          приобретать дополнительные акции на полученные дивиденды, что увеличивает потенциальный доход 
          в будущем за счет сложного процента.
        </p>
      </div>
    </div>
  );
};

export default GrowthSection;